import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import CELLS from "vanta/dist/vanta.cells.min";

const VantaBackground = () => {
  const vantaRef = useRef(null);
  const effectRef = useRef<any>(null);

  useEffect(() => {
    if (!effectRef.current) {
      effectRef.current = CELLS({
        el: vantaRef.current,
        THREE: THREE,
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        scale: 1.0,
        color1: 0x111827,
        color2: 0x62af62,
        size: 1.4,
        speed: 1.4,
      });
    }

    return () => {
      if (effectRef.current) effectRef.current.destroy();
    };
  }, []);

  return (
    <div
      ref={vantaRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -1,
      }}
    />
  );
};

export default VantaBackground;
